export default "__VITE_ASSET__qX2_Tg$N__"